/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PointCategory
 */
export interface PointCategory {
    /**
     * 포인트 구분 id
     * @type {number}
     * @memberof PointCategory
     */
    'pointCategoryId': number;
    /**
     * 카테고리
     * @type {string}
     * @memberof PointCategory
     */
    'category': PointCategoryCategoryEnum;
}

export const PointCategoryCategoryEnum = {
    Click: 'click',
    Install: 'install',
    Post: 'post',
    Etc: 'etc',
    Auto: 'auto',
    Plus: 'plus',
    Supporters: 'supporters',
    Guardian: 'guardian',
    Admin: 'admin',
    System: 'system'
} as const;

export type PointCategoryCategoryEnum = typeof PointCategoryCategoryEnum[keyof typeof PointCategoryCategoryEnum];


